<div
    [ngClass]="isSelected ? 'tw-bg-blue-100' : 'tw-bg-white'"
    class="tw-rounded-xl tw-border tw-border-gray-300 tw-p-3 tw-mx-auto tw-w-full"
>
    <div
        class="img-area tw-bg-white tw-relative tw-w-full tw-h-[187px] tw-rounded-xl tw-mb-2"
        [ngClass]="!isSelected ? 'tw-border tw-border-gray-300' : ''"
    >
        <img
            class="tw-w-[50vw] md:tw-w-[100%] tw-h-[100%] tw-mx-auto"
            [src]="getImgUrl(productDetails.fiImage)"
            alt="Product"
        />
        <span
            *ngIf="!isP2POnly && product.prodCat !== 'DIGITAL BANK'"
            [ngClass]="
                isNextRow
                    ? 'tw-bg-orange-200 tw-text-[#E2810E]'
                    : 'tw-text-[#4B6EEC] tw-bg-blue-200'
            "
            class="tw-absolute tw-flex tw-items-center tw-text-[12px] tw-font-bold tw-gap-2 tw-right-2 tw-top-2 tw-rounded-full tw-py-2 tw-px-4"
        >
            <svg
                *ngIf="!isNextRow"
                width="13"
                height="14"
                viewBox="0 0 13 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M11.8714 8.52297L6.80893 13.5855C6.75669 13.6378 6.69465 13.6793 6.62636 13.7076C6.55807 13.7359 6.48488 13.7504 6.41096 13.7504C6.33704 13.7504 6.26384 13.7359 6.19555 13.7076C6.12727 13.6793 6.06523 13.6378 6.01299 13.5855L0.950489 8.52297C0.844941 8.41742 0.785645 8.27427 0.785645 8.125C0.785645 7.97573 0.844941 7.83258 0.950489 7.72703C1.05604 7.62148 1.19919 7.56219 1.34846 7.56219C1.49772 7.56219 1.64088 7.62148 1.74643 7.72703L5.84846 11.8298V0.8125C5.84846 0.663316 5.90772 0.520242 6.01321 0.414753C6.1187 0.309263 6.26177 0.25 6.41096 0.25C6.56014 0.25 6.70322 0.309263 6.80871 0.414753C6.91419 0.520242 6.97346 0.663316 6.97346 0.8125V11.8298L11.0755 7.72703C11.181 7.62148 11.3242 7.56219 11.4735 7.56219C11.6227 7.56219 11.7659 7.62148 11.8714 7.72703C11.977 7.83258 12.0363 7.97573 12.0363 8.125C12.0363 8.27427 11.977 8.41742 11.8714 8.52297Z"
                    fill="#4B6EEC"
                />
            </svg>

            <svg
                *ngIf="isNextRow"
                width="13"
                height="18"
                viewBox="0 0 13 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12.5838 8.30894C12.5625 8.21879 12.5192 8.13529 12.4579 8.06586C12.3966 7.99643 12.319 7.94323 12.2322 7.91097L8.1815 6.39152L9.21228 1.2355C9.23562 1.1157 9.21937 0.991566 9.16597 0.881818C9.11257 0.77207 9.02492 0.682668 8.91625 0.627104C8.80758 0.571539 8.68379 0.552826 8.56355 0.57379C8.44332 0.594753 8.33316 0.654254 8.24971 0.743315L0.374706 9.18082C0.310746 9.24821 0.264477 9.3304 0.240032 9.42004C0.215587 9.50968 0.213727 9.60398 0.23462 9.69451C0.255512 9.78505 0.298506 9.869 0.359759 9.93886C0.421013 10.0087 0.498619 10.0623 0.585643 10.0949L4.63775 11.6143L3.60978 16.7647C3.58644 16.8845 3.6027 17.0087 3.6561 17.1184C3.7095 17.2282 3.79715 17.3176 3.90582 17.3731C4.01449 17.4287 4.13828 17.4474 4.25852 17.4264C4.37875 17.4055 4.48891 17.346 4.57236 17.2569L12.4474 8.81941C12.5102 8.752 12.5554 8.6702 12.5792 8.58119C12.603 8.49218 12.6046 8.39869 12.5838 8.30894ZM5.10111 15.047L5.83728 11.364C5.86363 11.2334 5.84275 11.0977 5.77837 10.981C5.71399 10.8643 5.61028 10.7743 5.48572 10.727L1.77041 9.33128L7.72025 2.95675L6.98478 6.63972C6.95844 6.77034 6.97931 6.90607 7.0437 7.02273C7.10808 7.1394 7.21179 7.22941 7.33635 7.27675L11.0488 8.66894L5.10111 15.047Z"
                    fill="#E2810E"
                />
            </svg>

            {{
                isNextRow
                    ? ("PRODUCT_MATCHING.PROCESSING_TIME" | translate)
                    : ("PRODUCT_MATCHING.INTEREST_RATE" | translate)
            }}
        </span>
        <!-- Fast Transfer badge for Digital Bank products - replaces the Interest Rate/Processing Time badge -->
        <span
            *ngIf="!isP2POnly && product.prodCat === 'DIGITAL BANK'"
            class="tw-absolute tw-flex tw-items-center tw-text-[12px] tw-font-bold tw-gap-2 tw-right-2 tw-top-2 tw-rounded-full tw-py-2 tw-px-4 tw-text-[#1886FD] tw-bg-blue-200"
        >
            <img
                src="/assets/images/icons/dollarBill.svg"
                alt="Dollar Bill"
                width="13"
                height="14"
            />
            {{"PRODUCT_MATCHING.FAST_TRANSFER" | translate}}
        </span>
        <span
            class="tw-px-3 tw-py-2 tw-font-bold tw-rounded-r-full tw-text-white tw-absolute tw-left tw-top-2 tw-text-[12px]"
            [ngClass]="{
                'tw-bg-[#795CFC]':
                    product.prodCat == 'BANK' ||
                    product?.productCategory == 'BANK',
                'tw-bg-blue-900':
                    product.prodCat == 'CGC' ||
                    product?.productCategory == 'CGC',
                'tw-bg-[#FFA53C]':
                    product.prodCat == 'P2P' ||
                    product?.productCategory == 'P2P',
                'tw-bg-[#007AFF]':
                    product.prodCat == 'DIGITAL BANK' ||
                    product?.productCategory == 'DIGITAL BANK'
            }"
        >
            {{
                product.prodCat == "BANK"
                    ? (product.prodCat | titlecase)
                    : product.prodCat || product?.productCategory
            }}
        </span>
    </div>
    <div class="tw-flex tw-flex-col tw-items-center">
        <h3 class="!tw-text-[18px] !tw-h-[82px] !tw-font-bold !tw-text-center">
            {{ product.productName }}
        </h3>
    </div>
    <div class="tw-grid tw-grid-cols-2 tw-gap-2">
        <div class="tw-flex tw-flex-col tw-gap-1">
            <span
                class="tw-bg-gray-300 tw-text-gray-600 tw-text-[14px] tw-rounded-sm tw-px-1 tw-py-[2px]"
            >
                {{ "COMMON.FINANCING" | translate }}
            </span>
            <span class="tw-font-bold tw-px-1 tw-py-[2px] tw-text-[14px]">
                RM {{ product.prodFinAmtMin | number }} -
                <br class="tw-hidden md:tw-block" />
                RM {{ product.prodFinAmtMax | number }}
            </span>
        </div>
        <div class="tw-flex tw-flex-col tw-gap-1">
            <span
                class="tw-bg-gray-300 tw-text-gray-600 tw-text-[14px] tw-rounded-sm tw-px-1 tw-py-[2px]"
                >{{ "PRODUCT_MATCHING.PROCESSING" | translate }}</span
            >
            <span class="tw-font-bold tw-px-1 tw-py-[2px] tw-text-[14px]"
                >{{ product.prodTat }} ({{
                    "PRODUCT_MATCHING.WORKING_DAYS" | translate
                }})
            </span>
        </div>
        <div class="tw-flex tw-flex-col tw-gap-1">
            <span
                class="tw-bg-gray-300 tw-text-gray-600 tw-text-[14px] tw-rounded-sm tw-px-1 tw-py-[2px]"
            >
                {{ "PRODUCT_MATCHING.TENURE" | translate }}</span
            >
            <span class="tw-font-bold tw-px-1 tw-py-[2px] tw-text-[14px]">
                {{ product.prodTenure }} ({{
                    "PRODUCT_MATCHING.YEARS" | translate
                }})</span
            >
        </div>
        <div class="tw-flex tw-flex-col tw-gap-1">
            <span
                class="tw-bg-gray-300 tw-text-gray-600 tw-text-[14px] tw-rounded-sm tw-px-1 tw-py-[2px]"
            >
                {{ "PRODUCT_MATCHING.INTEREST" | translate }}</span
            >
            <span class="tw-font-bold tw-px-1 tw-py-[2px] tw-text-[14px]"
                >{{ "PRODUCT_MATCHING.FROM" | translate }}
                {{ product.prodInterestRate }}%
                {{ "PRODUCT_MATCHING.PA" | translate }}</span
            >
        </div>
    </div>
    <ng-container *ngIf="showMore">
        <p
            class="!tw-my-2 !tw-text-gray-500 !tw-text-[14px]"
            *ngIf="selectedLanguage == 'en'"
            [innerHtml]="product.productDescEng"
        >
            {{ product.productDescEng }}
        </p>
        <p
            class="!tw-my-2 !tw-text-gray-500 !tw-text-[14px]"
            *ngIf="selectedLanguage == 'bm'"
            [innerHtml]="product.productDescBm"
        >
            {{ product.productDescBm }}
        </p>
    </ng-container>
    <button
        class="tw-cursor-pointer tw-mx-auto tw-flex tw-items-center tw-justify-center tw-my-2 tw-text-[14px] tw-text-gray-500"
        (click)="toggleDesc()"
    >
        {{
            showMore
                ? ("PRODUCT_MATCHING.SHOW_LESS" | translate)
                : ("PRODUCT_MATCHING.SHOW_MORE" | translate)
        }}
        <mat-icon>{{ showMore ? "expand_less" : "expand_more" }}</mat-icon>
    </button>

    <button
        (click)="
            !changeBranch && productDetails.branchActive === 'Y'
                ? showDialogBox()
                : onSelectProduct(product.prodCode, product.prodCat)
        "
        [disabled]="!isSelected && limitExceeded"
        [attr.ga-event-id]="gaEventId"
        [attr.ga-event-category]="gaEventCategory"
        [attr.ga-event-label]="gaEventLable"
        ga-track="track"
        [ngClass]="
            faSelected
                ? 'tw-bg-[#A2A2A2]'
                : isSelected
                ? 'tw-bg-blue-900 hover:tw-bg-blue-950'
                : 'tw-bg-[#4A6EEC] hover:tw-bg-blue-600'
        "
        class="tw-text-white tw-py-4 disabled:tw-bg-[#A2A2A2] tw-flex tw-items-center tw-text-center tw-justify-center tw-gap-1 tw-rounded-full tw-cursor-pointer tw-w-full tw-transition-all"
    >
        <mat-icon *ngIf="isSelected">check_circle_outline</mat-icon>
        {{
            isSelected
                ? ("PRODUCT_MATCHING.SELECTED" | translate)
                : ("PRODUCT_MATCHING.SELECT" | translate)
        }}
    </button>

    <ng-container *ngIf="!isP2POnly && changeBranch">
        <div
            *ngIf="productDetails.branchActive === 'Y' && showBranch"
            class="tw-bg-white tw-rounded-xl tw-flex tw-flex-col tw-text-center tw-p-3 tw-gap-2 tw-max-w-[250px] tw-mx-auto tw-my-5"
        >
            <div class="tw-flex tw-flex-col tw-items-center tw-gap-1">
                <span
                    class="tw-text-blue-600 tw-text-[14px] tw-font-semibold"
                    >{{ "PRODUCT_MATCHING.BRANCH_LOCATION" | translate }}</span
                >
                <p class="!tw-font-semibold">{{ currentBranch?.branchName }}</p>
            </div>
            <hr class="tw-border-blue-600" />
            <div
                *ngIf="currentBranch?.officerName"
                class="tw-flex tw-flex-col tw-items-center tw-gap-1"
            >
                <span
                    class="tw-text-blue-600 tw-text-[14px] tw-font-semibold"
                    >{{ "PRODUCT_MATCHING.OFFICER_NAME" | translate }}</span
                >
                <p class="!tw-font-semibold">
                    {{ currentBranch?.officerName }}
                </p>
            </div>
            <button
                (click)="showDialogBox()"
                class="tw-block tw-w-[80%] tw-cursor-pointer tw-text-[14px] tw-mx-auto tw-rounded-full tw-border tw-border-blue-400 tw-font-semibold tw-py-[5px]"
            >
                <ng-container>
                    {{
                        (changeBranch
                            ? "SELECT_BRANCH.CHANGE"
                            : "SELECT_BRANCH.SELECT_NOW"
                        ) | translate
                    }}
                </ng-container>
            </button>
        </div>
    </ng-container>
</div>
